/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { quizService } from '../api/quizService';
import { FunnelStep } from '../types/cards';
import Card from '../funnel/Card/Card';
import Header from '../components/Header/Header';
import './Quiz.css';
import { useFunnelStore } from '../store/useFunnelStore';

const LAST_VISITED_STEP_KEY = 'last_visited_step';

const Quiz: React.FC = () => {
    const { funnelId, stepIndex, version } = useParams<{ funnelId: string; stepIndex: string; version: string }>();
    const navigate = useNavigate();
    const [currentStep, setCurrentStep] = useState<FunnelStep | null>(null);
    const [selectedValues, setSelectedValues] = useState<string[]>([]);
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(true);
    const { setFunnel, funnel } = useFunnelStore();

    useEffect(() => {
        const fetchStep = async () => {
            setLoading(true);
            setError(null);
            if (!funnelId || !stepIndex) {
                setError('Missing funnel or step index');
                setLoading(false);
                return;
            }
            try {
                    // 1. Get funnel data from API
                    const funnelResponse: any = await quizService.getSelectedFunnel(funnelId);
                    if (!funnelResponse) {
                        setError('Funnel not found');
                        setLoading(false);
                        return;
                    }
                    setFunnel(funnelResponse);

                // 2. Find the step by array index (route is 1-based, array is 0-based)
                const stepNum = parseInt(stepIndex, 10) - 1;
                const step = funnelResponse.steps[stepNum];
                if (!step) {
                    setError('Step not found');
                    setLoading(false);
                    return;
                }
                // 3. Load step details
                const details = await quizService.getFunnelStepDetails(step.documentId || '', step.stepType || '');
                setCurrentStep(details);
                setLoading(false);
            } catch (err) {
                setError('Failed to load step');
                setLoading(false);
            }
        };
        fetchStep();
    }, [funnelId, stepIndex, version, setFunnel]);

    useEffect(() => {
        setSelectedValues([]);
    }, [currentStep]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [currentStep]);

    const handleSelect = (selection: { stepId: string; selectedOptionIds: string[]; isMultiSelect?: boolean }) => {
        setSelectedValues(selection.selectedOptionIds);
        // Only advance to next step if it's not a multi-select card
        if (!selection.isMultiSelect && currentStep) {
            const steps = (funnel?.steps || []);
            const currentIdx = steps.findIndex((s: any) => s.documentId === currentStep.documentId);
            const nextIdx = currentIdx + 1;
            const nextStep = steps[nextIdx];
            if (nextStep) {
                localStorage.setItem(LAST_VISITED_STEP_KEY, (nextIdx + 1).toString());
                navigate(`/quiz/${funnelId}/${nextIdx + 1}/v1`);
            } else {
                console.log('No next step found or end of funnel');
                // End of funnel or no more steps
                // You can redirect to a summary or finish page here
            }
        }
    };

    // if (loading) {
    //     return <div className="quiz quiz--loading">Loading step...</div>;
    // }
    if (error) {
        return <div className="quiz quiz--error">{error}</div>;
    }
    if (!currentStep) {
        return <div className="quiz quiz--empty"></div>;
    }

    return (
        <div className="quiz">
            <Header onMenuClick={() => {}} stepIndex={Number(stepIndex)} />
            <Card
                step={currentStep}
                version={version || 'v1'}
                onSelect={handleSelect}
                selectedValues={selectedValues}
                funnelId={funnelId || ''}
            />
        </div>
    );
};

export default Quiz;
